<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.prestadoresExternos"
            sort-by="destinoNome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.ModalExame.open(item)"
                    color="info"
                    small
                    title="Exames"
                >
                    <rkm-icon icon="dna" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalProcedimentoCirurgico.open(item)"
                    color="info"
                    small
                    title="Procedimentos cirúrgicos"
                >
                    <rkm-icon icon="pump-medical" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEspecialidade.open(item)"
                    color="info"
                    small
                    title="Especialidades"
                >
                    <rkm-icon icon="book-medical" />
                </rkm-button>

                <rkm-button
                    :color="item.ativo ? 'dark' : 'success'"
                    :title="item.ativo ? 'Desativar' : 'Ativar'"
                    @click="item.ativo = !item.ativo"
                    small
                >
                    <rkm-icon :icon="item.ativo ? 'ban' : 'check-circle'" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalExame ref="ModalExame" />
        <ModalProcedimentoCirurgico ref="ModalProcedimentoCirurgico" />
        <ModalEspecialidade ref="ModalEspecialidade" />
    </div>
</template>

<script>
// Components.
import ModalExame from './components/exame/Modal'
import ModalProcedimentoCirurgico from './components/procedimento-cirurgico/Modal'
import ModalEspecialidade from './components/especialidade/Modal'

export default {
    components: { ModalExame, ModalProcedimentoCirurgico, ModalEspecialidade },
    data: () => ({
        fields: [
            { key: 'destinoNome', label: 'Destino', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(prestador) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o prestador externo?',
                async () => this.data.model.prestadoresExternos
                    .splice(this.data.model.prestadoresExternos.indexOf(prestador), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>